<template>
  <CDialog v-model="isOpen">
    <header class="mrgb+">
      <h3 class="title">
        {{ $t('courseConnection.disableStationDialog.title') }}
      </h3>
      <p>
        {{ $t('courseConnection.disableStationDialog.description') }}
      </p>
      <h4 v-if="station">
        {{ station.name }}
      </h4>
      <div class="info-container">
        <Icon id="alert-circle-outline" class="icon" a></Icon>
        <p>{{ $t('courseConnection.disableStationDialog.warning') }}</p>
      </div>
    </header>
    <main class="dialog-body">
      <Form @passed="submit">
        <ListInline size="small" class="flex justify-content-between mrgt+">
          <li>
            <Btn variant="outline" @click="isOpen = false">
              {{ $t('common.cancel') }}
            </Btn>
          </li>
          <li>
            <Btn
              data-cy="save-button"
              type="submit"
              :disabled="loading"
              variant="primary"
            >
              <Loader v-if="loading" size="small" negative />
              <template v-else>
                {{ $t('common.disable') }}
              </template>
            </Btn>
          </li>
        </ListInline>
      </Form>
    </main>
  </CDialog>
</template>

<script>
import eventBus from '@/eventBus';
import Loader from '@/components/ui/Loader.vue';
import { mapActions } from 'vuex';

export default {
  components: { Loader },
  data() {
    return {
      isOpen: false,
      station: null,
      loading: false,
    };
  },
  mounted() {
    eventBus.$on('toggleStationDisablingDialog', this.handleToggle);
  },
  beforeDestroy() {
    eventBus.$off('toggleStationDisablingDialog', this.handleToggle);
  },
  methods: {
    ...mapActions('courses', ['deactivateCourseConnectionLocation']),
    handleToggle(station) {
      this.station = station;
      this.isOpen = !this.isOpen;
    },
    submit() {
      this.loading = true;
      this.deactivateCourseConnectionLocation(this.station.id)
        .then(() => {
          this.isOpen = false;
        })
        .catch(error => {
          this.$notify({
            type: 'error',
            title: this.$t('common.error'),
            text: error.message || error,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin-top: 15px;
  margin-bottom: 1.5em;
}
</style>
